import React, {useRef, useState} from 'react'
import {Button, Grid, TextField} from "@mui/material";
import classes from './SigningForm.module.css'
import {PDFDocument, rgb, StandardFonts} from 'pdf-lib';
import API from "../../adapters/API";
import CanvasDraw from "react-canvas-draw";
import BackDrop from "../../UI/backdrop/Backdrop";
import moment from "moment-timezone";

const SigningForm = (props) => {
    const [loading, setLoading] = useState(false);
    const canvasRef = useRef(null)

    const clearDrawing = async () => {
        canvasRef.current.eraseAll();
    }

    const CanvasOnChange = (e) => {
        // HACK: on samsung s21 first lines always disappear when drawing second
        const firstLine = e.lines[0]
        if (firstLine && e.lines.length === 2) {

            canvasRef.current.lines.push(firstLine)
            canvasRef.current.simulateDrawingLines(({
                lines: [firstLine],
                immediate: true
            }))
        }
    }
    const downloadBlob = (blob) => {

        const fileURL = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = "rc.pdf";
        link.click();
    }

    const signDocument = async () => {
        setLoading(true)
        const arr = await props.pdfBlob.arrayBuffer()
        const pdfDoc = await PDFDocument.load(arr)

        // Embed a font so we can measure text width
        const font = await pdfDoc.embedFont(StandardFonts.Helvetica)

        const image = canvasRef.current.canvasContainer.childNodes[1].toDataURL('image/png')
        const page = pdfDoc.getPage(0)
        const jpgImage = await pdfDoc.embedPng(image)

        const {width: pageWidth, height: pageHeight} = page.getSize()
        console.log(`width: ${pageWidth}`, `height ${pageHeight}`)
        const sigWidth = pageWidth / 5
        const sigHeight = (jpgImage.height / jpgImage.width) * sigWidth


        const sigX = (pageWidth - sigWidth) / 2
        const sigY = 20

        page.drawImage(jpgImage, {
            x: sigX,
            y: sigY,
            width: sigWidth,
            height: sigHeight,
        })

        const d = new Date()
        const tz = 'America/New_York'
        const dateFormat = 'YYYY/DD/MM hh:mm'
        const dateString = moment(d).tz(tz).format(dateFormat)

        const fontSize = 5



        const text = `${dateString} (EST), ip: ${props.ip} user agent: ${window.navigator.userAgent}`;
        const lineWidth = font.widthOfTextAtSize(text, fontSize)
        const x = (pageWidth - lineWidth) / 2
        const y = fontSize / 2
        console.log(x, y)
        console.log(x, y)
        page.drawText(text, {
            x,
            y,
            size: fontSize,
            font,
            color: rgb(0, 0.53, 0.71),
        })

        const pdfBytes = await pdfDoc.save()
        const bytes = new Uint8Array(pdfBytes)
        const PdfBlob = new Blob([bytes], {type: 'application/pdf'})
        const formData = new FormData();
        formData.append("pdf", PdfBlob);
        formData.append("code", props.code);


        const resp = await API.post('document/sign', formData);

        props.onSign()
        setLoading(false)
    }


    const validSignature = true
    const signatureWidth = Math.min(props.browserWidth * 0.7, 400)

    return (

        <div>
            {loading ? <BackDrop open={true}/> : null}
            <div style={{marginBottom: 20}} onClick={event => console.log(event)}>
                <div id={'canvasContainer'} style={{width: 'fit-content', margin: "auto", border: '2px solid black'}}>
                    <CanvasDraw lazyRadius={3} hideInterface onChange={CanvasOnChange} ref={canvasRef} brushRadius={3}
                                canvasWidth={signatureWidth} canvasHeight={200}/>
                </div>

            </div>
            <Grid container alignItems="center" justifyContent="space-evenly" spacing={0} className={classes.form}>
                <Grid item sm={2}>
                    <Button variant="contained" fullWidth={true} onClick={signDocument}
                            disabled={!validSignature || loading}>Sign
                        document</Button>
                </Grid>
                <Grid item sm={2}>
                    <Button variant="contained" fullWidth={true} onClick={clearDrawing}
                            disabled={!validSignature || loading}>Clear
                        signature</Button>
                </Grid>
            </Grid>

        </div>


    )
};


export default SigningForm
